var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHShape2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1914 10.7037C38.7042 15.625 34.7207 20.626 29.098 21.9832C25.5048 22.8506 21.1671 21.2132 19.2268 18.054C17.3942 15.0703 16.7938 11.2795 19.2871 8.52886C20.5866 7.09513 22.3504 6.41436 24.1225 7.4793C26.8299 9.10627 27.2384 13.5614 26.6497 16.3147C24.8124 24.9073 17.5114 33.0027 9.00284 35.3523",
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4681 36.6612C13.9319 36.5208 10.4357 36.0919 8.74037 35.4996",
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74036 35.4996C9.58713 34.2103 11.4288 31.2077 12.0211 29.5123",
    stroke: "#1D2433",
    strokeOpacity: 0.65,
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHShape2);
export default __webpack_public_path__ + "static/media/h-shape2.2832c8ce3402326ddfba35824861aa09.svg";
export { ForwardRef as ReactComponent };